module.exports = __webpack_public_path__ + "static/media/PERSONALIZE_IMG.a4d04897.png";